// ЕДИНАЯ шкала слоёв портала (z-index).
//
// ЗАЧЕМ. Аудит 08.08 нашёл ~20 разных значений z-index, расставленных на глаз:
// z-30, z-50, z-[60], z-[65], z-[70], z-[80], z-[95], z-[120], z-[200], z-[1000],
// z-[1300], z-[9998], z-[10000], z-[10060], z-[10080]. Каждый новый экран
// подбирал число «чтобы перекрыло соседа», и это давало настоящие баги:
//   • ToastHost жил на z-[100] — сообщение об ошибке пряталось ПОД любой
//     модалкой выше сотни (то есть почти под всеми);
//   • Select был на z-[200] с комментарием «выше модалок (HrModal z-[100])», но
//     под модалками z-[1000]+ выпадающий список уезжал под панель формы.
//
// ПРАВИЛО. Новый код не пишет z-index числом — берёт значение отсюда.
//
// ПОРЯДОК СЛОЁВ (снизу вверх):
//   контент → каркас/навигация → модалки → выпадающие слои → лайтбокс →
//   подтверждение → тосты
//
// Выпадающие слои (Select, Popover, DatePicker, Combobox) намеренно стоят ВЫШЕ
// модалок: список обязан раскрываться поверх формы, в которой он лежит.
//
// ПЕРЕХОДНЫЙ ПЕРИОД. Пока часть портала не переведена на общий <Modal>, в коде
// живут старые модалки вплоть до z-[10080]. Поэтому dropdown и всё, что выше,
// начинается от 10200 — чтобы перекрывать и наследство тоже. По мере перевода
// модулей эти числа можно будет опустить (см. MODAL ниже).
export const Z = {
  /** Липкие шапки и футеры внутри таблиц. */
  STICKY: 10,
  /** Полноэкранный режим HeatmapGrid — выше каркаса приложения. */
  GRID_FULLSCREEN: 45,
  /** Рельса навигации, мобильное меню, шапка приложения. */
  NAV: 60,
  /** Открытое мобильное меню навигации. ВЫШЕ баров отдела (они на NAV) и выше
   *  плавающей кнопки: меню открыто — оно и главное на экране.
   *  ⚠️ Было жёсткое `z-50`, то есть НИЖЕ баров отдела на Z.NAV=60, и меню
   *  открывалось под верхней полосой вкладок (Максим, 19.08.2026) — ровно тот
   *  случай, ради которого эта шкала и заведена. */
  NAV_OVERLAY: 80,

  /** Полоса загрузки по верхней кромке экрана (2 px). Выше навигации, но НИЖЕ
   *  модалок: открытый диалог — главное на экране, и тянуть под ним ниточку
   *  незачем. */
  TOP_PROGRESS: 90,

  /** Плавающая кнопка (запрос на доработку, ассистент) и её радиальное меню.
   *  Часть каркаса — обязана уходить ПОД открытый диалог, иначе перекрывает
   *  кнопку «Сохранить» в форме (на узком экране это и происходило). */
  FAB: 70,

  /** Плавающая командная панель из кружка (чат, задачи, доработки, помощник).
   *  ⚠️ НИЖЕ модалок — как и сам кружок. Панель закрывается прозрачным
   *  перехватчиком кликов во весь экран, и пока она стояла на уровне выпадашек
   *  (10200), этот невидимый лист лежал ПОВЕРХ окна, открытого из самой панели:
   *  любой клик по форме «В заявки на доработку» попадал в перехватчик и
   *  захлопывал панель вместе с окном (Максим, 24.08.2026). Форма обязана быть
   *  выше панели, из которой её открыли. */
  FLOAT_PANEL: 900,

  /** Модальные окна и выдвижные панели (Modal/Drawer). Вложенные поднимаются
   *  сами: каждый следующий уровень +MODAL_STEP (см. modal.tsx). */
  MODAL: 1000,
  MODAL_STEP: 20,

  /** Выпадающие слои: Select, Popover, DatePicker, Combobox. */
  DROPDOWN: 10200,
  /** Подсказки — поверх выпадающих списков (подсказка к пункту списка). */
  TOOLTIP: 10250,
  /** Просмотр картинки/видео во весь экран — поверх формы, из которой открыт. */
  LIGHTBOX: 10400,
  /** Диалог подтверждения — поверх любой формы, из которой его позвали. */
  CONFIRM: 10600,
  /** Палитра команд и плашка предпросмотра темы: системные слои поверх всего
   *  содержимого, но под диалогом подтверждения и тостами. */
  COMMAND: 10500,
  /** Тосты — всегда самый верх, их видно поверх чего угодно. */
  TOAST: 10800,

  /** Липкая горизонтальная полоса прокрутки: поверх содержимого и
   *  полноэкранной таблицы, но под навигацией и любыми окнами. */
  SCROLLBAR: 50,
} as const;
